// extracted by mini-css-extract-plugin
export default {"TweetItemContainer":"TweetItemCollection_TweetItemContainer__+iTRS"};